enum EquipmentTypes {
  GUN = 'GUN',
  AMMO = 'AMMO',
  USES = 'USES',
  EMPTY = 'EMPTY',
  ARMOR = 'ARMOR',
  BASIC = 'BASIC',
}
export default EquipmentTypes
